<template>
  <div>
    <div><el-button size="mini" @click="goTo(0)" class="category add">新增</el-button></div>
    <el-table
        :data="tableData"
        style="width: 100%">
      <el-table-column
          label="ID"
          width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px" >{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="分类标题">
        <template slot-scope="scope">
          <span style="margin-left: 10px" v-html="scope.row.cate_name"></span>
        </template>
      </el-table-column>
      <el-table-column
          label="类型"
          width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px" v-html="scope.row.type"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="goTo(scope.row.id)">编辑</el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleteBanner(scope.$index,scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "LabelView",
  data() {
    return {
      tableData: [],
      id: '',
      total: 100,
    }
  },
  components:{
  },
  created() {
    this.getCate();
  },
  methods: {
    goTo(id){
      this.$router.push('/getLabel/'+id)
    },
    getCate(){
      axios.get('/api/Cate/cate.html').then((res)=>{
        if(res.data.code == 200){
          this.tableData = res.data.data;
        }
      });
    },
    deleteBanner(index,row){
      let tdata = this.tableData;
      this.$confirm("是否确认删除","提示",{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
      }).then(function (){
        axios.delete('/api/Cate/deleteCate.html',{data:{id:row.id}}).then((res)=>{
          tdata.splice(index, 1);
          alert(res.data.msg)
        });
      }).catch(function (){

      })

    }
  }
};
</script>
<style scoped lang=''>
</style>